import { createVNode as _createVNode, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-77c53659")

_pushScopeId("data-v-77c53659")
const _hoisted_1 = {
  key: 0,
  class: "toc_ui__entrust_main",
  id: "entrust"
}
const _hoisted_2 = { class: "toc_ui__entrust_body" }
const _hoisted_3 = { class: "switch" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "xctxt" }, "只看瑕疵", -1)
const _hoisted_5 = { class: "allOk" }
const _hoisted_6 = { class: "entrust-main" }
const _hoisted_7 = { class: "entrust-img" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Switch = _resolveComponent("Switch")
  const _component_componentTitle = _resolveComponent("componentTitle")

  return (_ctx.state.entrustList)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("img", {
          class: "weituoBg",
          src: require("../../../assets/tocV3/weituoBg.png")
        }, null, 8, ["src"]),
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_componentTitle, { title: "委托检测项" }, {
            default: _withId(() => [
              _withDirectives(_createVNode("div", _hoisted_3, [
                _hoisted_4,
                _createVNode(_component_Switch, {
                  modelValue: _ctx.state.onlyFlaw,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.onlyFlaw = $event)),
                  onChange: _ctx.changeShowFlaw
                }, null, 8, ["modelValue", "onChange"])
              ], 512), [
                [_vShow, _ctx.state.hasWarn]
              ]),
              _withDirectives(_createVNode("div", _hoisted_5, "全部检测无瑕疵", 512), [
                [_vShow, !_ctx.state.hasWarn]
              ])
            ]),
            _: 1
          }),
          _createVNode("div", _hoisted_6, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.entrustList, (item) => {
              return (_openBlock(), _createBlock("div", {
                class: "entrust-main-item",
                key: item.code,
                onClick: ($event: any) => (_ctx.clickTab(item.code))
              }, [
                _createVNode("div", _hoisted_7, [
                  _createVNode("img", {
                    src: item.iconUrl,
                    alt: ""
                  }, null, 8, ["src"])
                ]),
                _createVNode("p", null, _toDisplayString(item.name), 1)
              ], 8, ["onClick"]))
            }), 128))
          ])
        ])
      ]))
    : _createCommentVNode("", true)
})